let url = "";

if (process.env.NODE_ENV === 'development') {
	// In dev, default to talking to the same host the page was loaded from,
	// on port 8000. Lets the SPA work from localhost, a LAN IP, or a local
	// hostname (e.g. smarttools.home.lan) without rebuilding. REACT_APP_API_URL
	// still wins as an explicit override if set.
	const fromWindow = typeof window !== "undefined" && window.location
		? `${window.location.protocol}//${window.location.hostname}:8000`
		: "http://localhost:8000";
	url = process.env.REACT_APP_API_URL || fromWindow;
} else {
	url = "https://api.dev-smartcuffs.com";
}

export const Constants = {
	url: url,
	baseUrl: url + "/api/admin",
};
